import {Component, Input} from '@angular/core';
import {PaginatedResponse} from '@gatewee/types/system';
import {Transaction} from '@gatewee/types/transaction';

@Component({
  selector: 'gatewee-recent-transactions',
  templateUrl: './recent-transactions.component.html',
  styleUrls: ['./recent-transactions.component.css'],
  standalone: false,
})
export class RecentTransactionsComponent {
  @Input() transactions?: PaginatedResponse<Transaction>;

  get isLoading(): boolean {
    return !this.transactions;
  }

  get hasTransactions(): boolean {
    return !!this.transactions && this.transactions.count > 0;
  }
}
